module.exports = {"available":"Volno","booked":"Obsazeno","occupied":"Obsazeno","booked-occupied":"Obsazeno / Obsazeno","used":"Právě uvolněno","until":"do","all-day":"Celý den","page_over_total":"Strana {page} z {total}","room-name":"Název místnosti","current-booking":"Probíhá","next-booking":"Následující","unknown":"Neznámý stav","floors":"Poschodí","today":"Dnes","no_bookings":"Dnes nejsou naplánovány žádné schůzky.","no_information":"Žádné informace.","description":"Popis","capacity":"Kapacita","allocated":"Přiřazeno","booked-occupied-allocated":"Obsazeno / Obsazeno / Přiřazeno"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/cs.json
// module id = Nneu
// module chunks = 2